export function createBreakpointInheritanceMap(breakpoints) {
  const sortedBreakpoints = [...breakpoints].sort((a, b) => {
    var _a$previewWidth$value, _a$previewWidth, _b$previewWidth$value, _b$previewWidth;
    const aWidth = (_a$previewWidth$value = (_a$previewWidth = a.previewWidth) === null || _a$previewWidth === void 0 ? void 0 : _a$previewWidth.value) !== null && _a$previewWidth$value !== void 0 ? _a$previewWidth$value : Infinity;
    const bWidth = (_b$previewWidth$value = (_b$previewWidth = b.previewWidth) === null || _b$previewWidth === void 0 ? void 0 : _b$previewWidth.value) !== null && _b$previewWidth$value !== void 0 ? _b$previewWidth$value : Infinity;
    if (aWidth === bWidth) {
      return 0;
    }
    return bWidth - aWidth;
  });
  const map = {};
  for (let i = sortedBreakpoints.length - 1; i > 0; i--) {
    map[sortedBreakpoints[i].name] = sortedBreakpoints[i - 1].name;
  }
  return map;
}

/**
 * Returns the non-layout styles of an EditorProvidedModuleStyle for pegboard modules.
 * @param styles - The EditorProvidedModuleStyle to get the non-layout styles of.
 * @returns The non-layout styles of the EditorProvidedModuleStyle.
 */
export function getNonLayoutStyles(styles) {
  return {
    isManuallyPositioned: styles.isManuallyPositioned
  };
}